// src/components/AdminDashboard.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = ({ onLogout }) => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTickets = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/tickets`);
        setTickets(response.data);
      } catch (error) {
        console.error('Failed to fetch tickets:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchTickets();
  }, []);

  const handleToggleResolved = async (ticketId, resolved) => {
    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/admin/tickets/${ticketId}/status`, { resolved });
      setTickets((prevTickets) =>
        prevTickets.map((ticket) =>
          ticket.id === ticketId ? { ...ticket, resolved } : ticket
        )
      );
    } catch (error) {
      console.error('Failed to update ticket status:', error);
    }
  };

  const handleDeleteTicket = async (ticketId) => {
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/admin/tickets/${ticketId}`);
      setTickets((prevTickets) => prevTickets.filter((ticket) => ticket.id !== ticketId));
    } catch (error) {
      console.error('Failed to delete ticket:', error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminLoggedIn'); // Clear admin session
    onLogout(); // Notify the App component that the user has logged out
    navigate('/'); // Redirect to login page
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="bg-[#1c1c24] min-h-screen p-8">
      {/* Logout Button */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-white">Admin Dashboard</h1>
        <button
          onClick={handleLogout}
          className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none"
        >
          Logout
        </button>
      </div>

      {/* Tickets List */}
      <div className="grid grid-cols-1 gap-6">
        {tickets.map((ticket) => (
          <div key={ticket.id} className="bg-[#2a2a33] p-4 rounded-lg">
            <h3 className="text-lg font-semibold text-white">{ticket.title}</h3>
            <p className="text-gray-400 mt-2">Category: {ticket.category}</p>
            <p className="text-gray-400 mt-2">Description: {ticket.description}</p>
            <div className="mt-4 flex gap-4">
              <button
                onClick={() => handleToggleResolved(ticket.id, !ticket.resolved)}
                className={`px-4 py-2 rounded-md ${
                  ticket.resolved ? 'bg-green-500' : 'bg-red-500'
                } text-white`}
              >
                {ticket.resolved ? 'Mark Unresolved' : 'Mark Resolved'}
              </button>
              <button
                onClick={() => handleDeleteTicket(ticket.id)}
                className="px-4 py-2 bg-red-600 text-white rounded-md"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;